// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"473":"ffmpeg-util","524":"ffmpeg-core"}[chunkId] || chunkId) + "." + {"473":"a5dc228a","486":"b9cdf890","524":"02bcd6a7","726":"49824d7a","816":"07458251"}[chunkId] + ".chunk.js";
};